// export const generateCode = (tasks, stationSelected) => {
//   console.log("stationSelected", stationSelected, tasks);
//   let code = `(async()=>{

//         this.utensil = '${stationSelected}';\n`;

//   for (const t of tasks) {
//     console.log("t", t?.cookIn);
//     code += t.code
//       .replaceAll("$water_ml", t.quantity)
//       .replaceAll("$bottle_ml", t.quantity)
//       .replaceAll("$grain_box", t.position)
//       .replaceAll("$spice_box", t.position)
//       .replaceAll("$grain_w", t.quantity)
//       .replaceAll("$spice_w", t.quantity)
//       .replaceAll("$bottle_oil", ["olive", "mustard"][t.position - 1])
//       .replaceAll("$squeeze_times", t.quantity)
//       .replaceAll("$stir_times", t.quantity)
//       .replaceAll("$wait_second", t.quantity)
//       .replaceAll("$washFor", t.quantity)
//       .replaceAll("$bowl_no", t.position)
//       .replaceAll("$cup_no", t.position)
//       .replaceAll("$stir_speed", t.speed);

//     code += "\n";
//   }

//   code += "})();\n";
//   return code;
// };

export const generateCode = (tasks) => {
  if (!Array.isArray(tasks)) {
    throw new Error("Invalid input: `tasks` must be an array.");
  }

  console.log("Tasks:", tasks);

  // Initialize the code string
  let code = `async function start() {\n`;

  // Process each task
  for (const task of tasks) {
    if (!task.code || !task.cookIn) {
      console.warn("Task missing `code` or `cookIn`:", task);
      continue;
    }

    // Set `this.utensil` dynamically for each task
    code += `  this.utensil = '${task.cookIn}';\n`;

    // Replace placeholders in the task's code
    const updatedCode = task.code
      .replaceAll("$water_ml", task.quantity)
      .replaceAll("$bottle_ml", task.quantity)
      .replaceAll("$grain_box", task.position)
      .replaceAll("$spice_box", task.position)
      .replaceAll("$grain_w", task.quantity)
      .replaceAll("$spice_w", task.quantity)
      .replaceAll(
        "$bottle_oil",
        ["olive", "mustard"][task.position - 1] || "default"
      )
      .replaceAll("$squeeze_times", task.quantity)
      .replaceAll("$stir_times", task.quantity)
      .replaceAll("$wait_second", task.duration)
      .replaceAll("$washFor", task.quantity)
      .replaceAll("$bowl_no", task.position)
      .replaceAll("$cup_no", task.position)
      .replaceAll("$stir_speed", task.speed);

    code += `  ${updatedCode}\n`;
  }

  // Close the async function
  code += "};\n";
  code += "start();";
  return code;
};

// export const generateCode = (tasks) => {
//   if (!Array.isArray(tasks)) {
//     throw new Error("Invalid input: tasks must be an array");
//   }

//   let code = `(async () => {\n`;
//   let currentCookIn = null;
//   let utensilDeclared = false;

//   for (const [index, task] of tasks.entries()) {
//     if (!task?.code || !task?.cookIn) {
//       console.warn(`Skipping invalid task at index ${index}`);
//       continue;
//     }

//     // Update utensil declaration when cookIn changes
//     if (task.cookIn !== currentCookIn) {
//       if (utensilDeclared) {
//         code += `  utensil = '${task.cookIn}';\n`;
//       } else {
//         code += `  let utensil = '${task.cookIn}';\n`;
//         utensilDeclared = true;
//       }
//       currentCookIn = task.cookIn;
//     }

//     // Replacement map for placeholders
//     const replacements = {
//       water_ml: task.quantity,
//       bottle_ml: task.quantity,
//       grain_box: task.position,
//       spice_box: task.position,
//       grain_w: task.quantity,
//       spice_w: task.quantity,
//       bottle_oil: ["olive", "mustard"][task.position - 1] || "default",
//       squeeze_times: task.quantity,
//       stir_times: task.quantity,
//       wait_second: task.quantity,
//       washFor: task.quantity,
//       bowl_no: task.position,
//       cup_no: task.position,
//       stir_speed: task.speed,
//     };

//     // Process code with replacements
//     const processedCode = task.code
//       .replace(/\bthis\.utensil\b/g, "utensil")
//       .replace(/\$(\w+)/g, (_, placeholder) => {
//         const value = replacements[placeholder];
//         return value !== undefined
//           ? value
//           : `[ERROR: Unknown placeholder $${placeholder}]`;
//       })
//       .replace(/,\s*$/, ""); // Remove trailing commas

//     code += `  ${processedCode}\n`;
//   }

//   code += "})();";
//   return code;
// };
